class PreviewerSEO {

    constructor(element) {

        this.element = $(element);

        this.language = this.element.data('language');

        this.slugPrefix = this.element.data('slug-prefix') != ''
            ? this.element.data('slug-prefix')
            : false;

        this.slugSuffix = this.element.data('slug-suffix') != ''
            ? this.element.data('slug-suffix')
            : false;

        this.input = [{
                'element': '.title',
                'inputs': this.element.data('title').split(','),
                'prefix': false,
                'suffix': false,
                'empty': '[ NO TITLE ]'
            }, {
                'element': '.slug',
                'prefix': this.slugPrefix,
                'suffix': this.slugSuffix,
                'slugify': true,
                'inputs': this.element.data('slug').split(','),
                'empty': '[ NO SLUG ]'
            }, {
                'element': '.description',
                'prefix': false,
                'suffix': false,
                'inputs': this.element.data('description').split(','),
                'empty': '[ NO DESCRIPTION ]'
            }
        ];

        this.events();

        this.setValues();
    }

    events() {

        let self = this,
            selectors = [],
            visibilitySwitch;

        if (typeof this.element.data('visibility-switch') != 'undefined' &&
            this.element.data('visibility-switch') != '') {

            this.element.data('visibility-switch').split(',').forEach(function(item, index) {
                selectors.push(item.replace(
                    /(.*)\[LANG\](.*)/gm, 
                    `$1`+self.language+`$2`
                ));
            });

            selectors = selectors.filter(function(value, index, self) {
                return self.indexOf(value) === index;
            });

            selectors.forEach(function(item, index) {
                $(document).on('change', item, function() {
                    self.setVisibility($(this).is(':checked'));
                });

                self.setVisibility($(item).is(':checked'));
            });
        }

        this.input.forEach(function(data, index) {

            data.inputs.forEach(function(item, index) {
                selectors.push(item.replace(
                    /(.*)\[LANG\](.*)/gm, 
                    `$1`+self.language+`$2`
                ));
            });
        });

        selectors = selectors.filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });
 
        selectors.forEach(function(item, index) {
            $(document).on('keyup change', item, function() {
                self.setValues();
            });
        });
    }

    setVisibility(state) {

        let selector = this.element.data('visibility-switch-selector').replace(
            /(.*)\[LANG\](.*)/gm, 
            `$1`+this.language+`$2`
        );

        if ($(selector).is(':hidden')) {
            $(selector).slideDown();
        }
        
        if (state === false) {
            $(selector).slideUp();
        }
    }

    setValues() {

        let self = this;
        this.input.forEach(function(item, index) {
            self.setInputValue(item);
        });
    }

    setInputValue(params) {

        let self = this,
            value = params.empty,
            inputValue;

        params.inputs.forEach(function(item, index) {
            inputValue = self.getInputValue(item);
            if (typeof inputValue != 'boolean') {
                value = inputValue;
            }
        });

        if (typeof params.slugify != 'undefined' &&
            params.slugify == true) {
            value = this.slugify(value, this.language);
        }

        if (value != params.empty) {
            if (params.prefix !== false) {
                value = params.prefix + value;
            }

            if (params.suffix !== false) {
                value = value + params.suffix;
            }
        }

        this.element.find(params.element).html(value);
    }

    getInputValue(element) {

        element = element.replace(
            /(.*)\[LANG\](.*)/gm, 
            `$1`+this.language+`$2`
        );

        if ($(element).length == 0 ||
            $(element).val() == '') {
            return false;
        }

        return $(element).val();
    }   

    slugify(string, language) {

        let slug,
            from = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;',
            to = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------',
            deFrom = 'Æ|Ǽ|ß|ä|æ|ǽ|ö|œ|ü|Ä|Ü|Ö',
            deTo = 'AE|AE|ss|ae|ae|ae|oe|oe|ue|Ae|Ue|Oe';
      
        //replace strange chars for german replacements
        if (language.toLowerCase() == 'de') {

            deFrom = deFrom.split('|');
            deTo = deTo.split('|');

            for (var i = 0, l = deFrom.length ; i < l ; i++) {
                string = string.replace(deFrom[i], deTo[i]);
            }
        }

        for (var i=0, l=from.length ; i<l ; i++) {
            string = string.replace(from.charAt(i), to.charAt(i));
        }
      
        slug = string
                .toLowerCase()
                .replace(/\s+/gi, '-')
                .replace(/(\s+|\-+)/gi, '-')
                .replace(/^\-/g, '')
                .replace(/\-$/g, '')
                .replace(/[^\w-]+/g,'')
                .split(' ').join('-');
                // .replace(/^[a-z0-9](?!.*?[^\na-z0-9]{2}).*?[a-z0-9]$/gmi);
      
        return slug;    
    }
}